/*eslint no-magic-numbers: [2, { "ignore": [0, 1, 300, 1000, 3600, 5000, 24] }]*/
import * as GlobalConstants from '../constants/globalConstants';
import { toast } from 'react-toastify';
import { AuthService } from '../../Auth/services/authServices';
import { globalConfig } from '../../../config/globalConfig';

class BaseService {
    static POST_METHOD            = 'post';
    static GET_METHOD             = 'get';
    static DEFAULT_ERROR_MESSAGE  = {
        'Error: Request failed with status code 404':
            'Ошибка! Страница не найдена',
    };
    static DEFAULT_TYPING_TIMEOUT = 300;
    static DEFAULT_TIMEOUT        = 5000;
    static millisecondsInSecond   = 1000;
    static secondsInHour          = 3600;
    static hourInDay              = 24;
    static CURRENT_WIDTH          = typeof window === 'undefined' ? 0 : window.innerWidth;
    static COOKIE_PREFIX          = 'WsKamBonus';
    static USER_INFO_COOKIE       = `userInfo${BaseService.COOKIE_PREFIX}`;

    static doPromise(dispatch, promise, withoutSpinner = false, withoutToast = false) {
        return new Promise((resolve, reject) => {
            if (!withoutSpinner && dispatch) {
                dispatch({
                    type: GlobalConstants.LOADING_START,
                });
            }
            return promise
                .then(res => {
                    if (!withoutSpinner && dispatch) {
                        dispatch({
                            type: GlobalConstants.LOADING_FINISH,
                        });
                    }
                    if (!!res && res.data.error) {
                        BaseService.showToast(toast.error(res.data.error));
                    }
                    if (!!res && res.data.message) {
                        BaseService.showToast(toast.success(res.data.message));
                    }
                    if (!res) {
                        return reject({});
                    }
                    return resolve(res.data ? res.data : {});
                })
                .catch(error => {
                    if (!withoutToast) {
                        BaseService.showToast(
                            toast.error(
                                BaseService.DEFAULT_ERROR_MESSAGE[error.toString()]
                                    ? BaseService.DEFAULT_ERROR_MESSAGE[error.toString()]
                                    : BaseService.parseErrorText(error.response),
                            ),
                        );
                    }
                    if (!withoutSpinner && dispatch) {
                        dispatch({
                            type: GlobalConstants.LOADING_FINISH,
                        });
                    }
                    return reject(error);
                });
        });
    }

    static parseErrorText(errorResponse = {}) {
        if (!!errorResponse && errorResponse.data && errorResponse.data.error) {
            return (
                errorResponse.data.error_description || errorResponse.data.error
            );
        }
        return !!errorResponse && errorResponse.data && errorResponse.data.message
            ? errorResponse.data.message
            : 'Неизвестная ошибка';
    }

    static showToast(toastId) {
        if (typeof window === 'undefined') {
            return;
        }
        window.setTimeout(
            () => toast.dismiss(toastId),
            BaseService.DEFAULT_TIMEOUT,
        );
    }

    /**
     * Проверяем переданые конфигурации
     */
    static checkConfig(config) {
        BaseService.trueConfig = true;
        if (config.isAuth) {
            BaseService.checkAuth();
        }
        return BaseService.trueConfig;
    }

    /**
     * На этой странице может находиться только авторизированный пользователь
     */
    static checkAuth() {
        if (!AuthService.getUserInfo()) {
            BaseService.trueConfig = false;
        }
    }

    static defaultCookieParams() {
        const replaceUrlRegExp = /(http|https):\/\//;
        let params             = {
            Path: '/',
        };
        if (process.env.NODE_ENV === 'development') {
            return params;
        }
        params.Domain = globalConfig.appDomain.replace(replaceUrlRegExp, '.');
        return params;
    }

    /**
     * Получить значение cookie
     * @param {string} cookieName
     * @returns {any}
     */
    static getCookieValue(cookieName) {
        let matches = document.cookie.match(new RegExp(
            `(?:^|; )${cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
        ));
        return matches ? decodeURIComponent(matches[1]) : null;
    }

    /**
     * Устанавливаем cookie с именем cookieName, значением cookieValue и параметрами cookieParams.
     * cookieParams - объект со свойствами cookie (expires, path, domain, secure)
     * @param cookieName
     * @param cookieValue
     * @param cookieParams
     */
    static setCookie(cookieName, cookieValue, cookieParams = null) {
        if (!cookieParams) {
            cookieParams = BaseService.defaultCookieParams();
        }
        const encodedValue = encodeURIComponent(cookieValue);
        let _cookieParams  = { ...cookieParams };
        let expires        = cookieParams.expires ? cookieParams.expires : BaseService.secondsInHour * BaseService.hourInDay;
        if (expires && typeof expires === 'number') {
            let dateNow = new Date();
            dateNow.setTime(dateNow.getTime() + expires * BaseService.millisecondsInSecond);
            expires = _cookieParams.expires = dateNow;
        }
        if (expires && expires.toUTCString) {
            _cookieParams.expires = expires.toUTCString();
        }
        let cookieContent = `${cookieName}=${encodedValue}`;
        /* eslint-disable */
        for (let paramName in _cookieParams) {
            cookieContent += `; ${paramName}`;
            const paramValue = _cookieParams[paramName];
            if (paramValue !== true) {
                cookieContent += `=${paramValue}`;
            }
        }
        /* eslint-enable */
        document.cookie = cookieContent;
    }

    /**
     * Удалить cookie
     * @param {string} cookieName
     */
    static deleteCookie(cookieName) {
        let params = BaseService.defaultCookieParams();
        params     = {
            ...params,
            expires: -1,
        };
        BaseService.setCookie(cookieName, '', params);
    }
}

export { BaseService };
